<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.sepaInfo.name"
            :error-messages="sepaInfoErrors['name']"
            :label="$t('sepaInfo.name')"
            @input="$v.item.sepaInfo.$touch()"
            @blur="$v.item.sepaInfo.$touch()"
            :success="success"
            :readonly="success"
          />
          <v-text-field
            v-model="item.sepaInfo.IBAN"
            :error-messages="sepaInfoErrors['IBAN']"
            :label="$t('sepaInfo.IBAN')"
            @input="$v.item.sepaInfo.$touch()"
            @blur="$v.item.sepaInfo.$touch()"
            :success="success"
            :readonly="success"
          />
          <v-text-field
            v-model="item.sepaInfo.BIC"
            :error-messages="sepaInfoErrors['BIC']"
            :label="$t('sepaInfo.BIC')"
            @input="$v.item.sepaInfo.$touch()"
            @blur="$v.item.sepaInfo.$touch()"
            :success="success"
            :readonly="success"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import { validationMixin } from 'vuelidate';

export default {
  name: 'PartyForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    },

    success: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  computed: {

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    sepaInfoErrors() {
      const errors = {};

      for (const k in this.item.sepaInfo) {
          if ( ! this.violations.hasOwnProperty('sepaInfo.' + k)) {
              continue;
          }
          if ( ! errors.hasOwnProperty(k)) {
              errors[k] = [];
          }
          errors[k].push(this.violations['sepaInfo.' + k]);
      }


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
  },
  validations: {
    item: {
      sepaInfo: {
      },
    }
  }
};
</script>
